import React from 'react';
import { useForm } from 'react-hook-form';

import Box from '@/main/components/shared/box';
import KogAutoCompleteControlled from '@/main/components/shared/inputAutoComplete/autoCompleteControlled';
import { KeyValue } from '@/main/models/common';
import { getTranslateByKey } from '@/main/services/utils';

import * as S from './styles';

interface ISectionEmailTemplateDataForm {
  country: KeyValue | null;
  insurer: KeyValue | null;
  systemApplication: KeyValue | null;
  templateType: KeyValue | null;
}

export interface ISectionEmailTemplateDataProps {
  country?: KeyValue | null;
  insurer?: KeyValue | null;
  systemApplication?: KeyValue | null;
  templateType?: KeyValue | null;
}

function SectionEmailTemplateData({
  country = null,
  insurer = null,
  systemApplication = null,
  templateType = null
}: ISectionEmailTemplateDataProps) {
  const ID_SCREEN = 'id-registerEmailTemplate';
  const generateIdScreen = (id: string) => `${ID_SCREEN}-${id}`;

  const { control, setValue } = useForm<ISectionEmailTemplateDataForm>({
    mode: 'onChange',
    defaultValues: {
      country: null,
      insurer: null,
      systemApplication: null,
      templateType: null
    }
  });

  return (
    <Box title={getTranslateByKey('information.generalData')}>
      <S.RowInputs>
        <KogAutoCompleteControlled
          id={generateIdScreen('select-country')}
          nameCustom="country"
          control={control}
          label={getTranslateByKey('information.country')}
          options={country ? [country] : []}
          rulesCustom={{ required: false }}
          errorMessageCustom=""
          hasErrorCustom={false}
          onChangeCustom={() => {}}
          valueDefaultKey={country?.key}
          setValueCustom={setValue}
          disabled
        />

        <KogAutoCompleteControlled
          id={generateIdScreen('select-insurer')}
          nameCustom="insurer"
          control={control}
          label={getTranslateByKey('information.insurer')}
          options={insurer ? [insurer] : []}
          rulesCustom={{ required: false }}
          errorMessageCustom=""
          hasErrorCustom={false}
          onChangeCustom={() => {}}
          valueDefaultKey={insurer?.key}
          setValueCustom={setValue}
          disabled
        />

        <KogAutoCompleteControlled
          id={generateIdScreen('select-systemApplication')}
          nameCustom="systemApplication"
          control={control}
          label={getTranslateByKey('information.systemApplication')}
          options={systemApplication ? [systemApplication] : []}
          rulesCustom={{ required: false }}
          errorMessageCustom=""
          hasErrorCustom={false}
          onChangeCustom={() => {}}
          valueDefaultKey={systemApplication?.key}
          setValueCustom={setValue}
          disabled
        />

        <KogAutoCompleteControlled
          id={generateIdScreen('select-templateType')}
          nameCustom="templateType"
          control={control}
          label={getTranslateByKey('information.templateType')}
          options={templateType ? [templateType] : []}
          rulesCustom={{ required: false }}
          errorMessageCustom=""
          hasErrorCustom={false}
          onChangeCustom={() => {}}
          valueDefaultKey={templateType?.key}
          setValueCustom={setValue}
          disabled
        />
      </S.RowInputs>
    </Box>
  );
}

export default SectionEmailTemplateData;
